import {requestGet, requestPost, requestUploadFile} from "./http"

import {apiPath} from "@/util/utils";
import {requestGetForm, requestPostForm} from "@/config/http-json";
const user = {
  async sendEmailCode(data) {
    const resp = await requestPost(`/front/${apiPath}/sendVerificationCode`, data)
    return resp
  },
  async register(data) {
    const resp = await requestPost(`/front/${apiPath}/register`, data)
    return resp
  },
  async login(data) {
    const resp = await requestPost(`/front/${apiPath}/doLogin`, data)
    return resp
  },

  async emailLogin(data) {
    const resp = await requestPost(`/front/${apiPath}/doLogin`, data)
    return resp
  },


  async sendVerificationCode(data) {
    const resp = await requestPostForm(`/front/${apiPath}/sendVerificationCodeByPhone`, data)
    return resp
  },

  async loginWithPhone(data) {
    const resp = await requestPostForm(`/front/${apiPath}/verifyVerificationCode`, data)
    return resp
  },
  async loginWithEmail(data) {
    const resp = await requestPost(`/front/${apiPath}/liberEmailDoLogin`, data)
    return resp
  },
  async updateUser(data) {
    const resp = await requestPost(`/front/${apiPath}/updateUser`, data)
    return resp
  },
  async fetchStores(data) {
    const resp = await requestGet(`/front/${apiPath}/getBrandShop`, data)
    return resp
  },
  async uploadFile(data) {
    const resp = await requestUploadFile(`/liber/user/uploadFile`, data)
    return resp
  },
  async userDevices() {
    const resp = await requestGet(`/front/${apiPath}/selectDeviceReceiptInfoList`)
    return resp
  },
  async activeWarranty(data) {
    const resp = await requestPost(`/front/${apiPath}/saveDeviceReceiptInfo`, data)
    return resp
  },
  async doneOnBoarding(data) {
    const resp = await requestGet(`/liber/user/readTheUserGuide`, data)
    return resp
  },
  async recentTimeUsages(data) {
    const resp = await requestGet(`/front/${apiPath}/selectRecentTimeUsageData`, data)
    return resp
  },
  async userDataIntegrity(data) {
    const resp = await requestGet(`/front/${apiPath}/selectUserDataIntegrity`, data)
    return resp
  },
  async sendRecoverYourPassword(data) {
    const resp = await requestPost(`/front/${apiPath}/recoverYourPassword`, data)
    return resp
  },
  async resetPassword(data) {
    const resp = await requestPost(`/front/${apiPath}/resetPassword`, data)
    return resp
  },
  async cartridgesList(data) {
    const resp = await requestGet(`/front/${apiPath}/selectUserUseTag`, data)
    return resp
  },
  async uploadFeedbackContent(data) {
    const resp = await requestPost(`/front/${apiPath}/uploadFeedbackContent`, data)
    return resp
  },
  async getUserPhoneByDevice(data) {
    const resp = await requestGetForm(`/front/${apiPath}/getUserPhoneByDevice`, data)
    return resp
  },
  async sendUnBindDeviceByPhone(data) {
    const resp = await requestPostForm(`/front/${apiPath}/sendUnBindDeviceByPhone`, data)
    return resp
  },
  async unBindDevice(data) {
    const resp = await requestPostForm(`/front/${apiPath}/unBindDevice`, data)
    return resp
  }
}

export default user
